<template>
    <div class="view">
      <cfhcoupon
      ref="coupon"
      :couponData="getMouldData()"
      v-on:showCouponClick="showCoupon"
      ></cfhcoupon>

      <div class="mask" v-if="showCouponView==true"></div>
      <cfhquestion
      v-if="showCouponView==true"
      :questionData='couponquestionData'
      :margintop='navHeight'
      v-on:closeCouponClick="closeCoupon"
      v-on:deleteCouponClick="deleteCoupon"
      ></cfhquestion>
    </div>
</template>

<script>
import cfhcoupon from '@/components/oui-cfhcoupon.vue';
import {
  userLogin,
  detailPushPage,
} from '@/utils/nativeBridge';
import NativeMsg from '@/base/NativeMsg';
import { getUserInfoForce } from '@fund/user-info';
import cfhquestion from '@/components/oui-cfhcouponquestion.vue';

export default {
  name: 'CouponBar',
  props: {},
  components: {
    cfhcoupon,
    cfhquestion,
  },
  data() {
    return {
      contentList: ['根据证监会规定，3月30日起，基金公司将对旗下部分产品持续持有期少于7个自然日的投资者收取不低于1.5%的赎回费，点此了解详情>>>', '策略选基抢占年前最后上车机会策略选基抢占年前最后上车机会'],
      closable: true,
      showIcon: true,
      show: true,
      warn_red_src: '@/assets/warn-tip-red.png',
      close_src: '@/assets/warn-tip-close.png',
      navHeight: 100,
      showCouponView: false,
      couponquestionData: {},
    };
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.handleDefault();
  },
  methods: {
    getMouldData() {
      return { Items: [] };
    },
    render() {
      // ss
    },
    closeCoupon() {
      this.showCouponView = false;
    },
    deleteCoupon() {
      // this.showCouponView = false;
      this.$refs.coupon.updateStateInGet();
    },
    async showCoupon(index, item) {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        detailPushPage({
          appId: '516939c37bdb4ba2b1138c50cf69a2e1',
          url: '/pages/FundTradeInfo',
          params: {
          },
        });
        return;
      }
      // #endif
      const info = await getUserInfoForce();
      const {
        uid,
      } = info;
      if (uid && uid.length > 0) {
        userLogin().then(() => {
          this.couponquestionData = item;
          this.showCouponView = true;
        }).catch(() => {
        });
      } else {
        userLogin().then(() => {
          setTimeout(() => {
            this.afterLogin();
          }, 500);
        }).catch(() => {
        });
      }
    },
    async afterLogin() {
      this.$feedback.showLoading({ title: '加载中...' });
      const userInfo = await getUserInfoForce();
      if (userInfo && userInfo.uid) {
        this.$http.setUserConfig(userInfo);
        // 直接重新调用 mutations
        this.fundCode = this.$store.state.native.fund.fundCode;
        this.reflashCon();
      }
    },
    async reflashCon() {
      await this.$store.dispatch('updateFundVarietyByFundCode', this.fundCode).catch((e) => {
        console.log(e);
      });
      this.$feedback.hideLoading();
      NativeMsg.post(JSON.stringify({ key: 'reflash', value: { v: 'start' } }));
    },
    handleDefault() {},
    clickAction() {
    },
    getshowListModule(Modules, code) {
      if (Modules) {
        const showModules = Modules.filter(
          (item) => (item.ModuleCode === code && item.CustomArray.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { CustomArray } = showModule;
          CustomArray = CustomArray.filter((item) => item.Link).map((item) => {
            const result = item;
            result.show = '1';
            return result;
          });
          return CustomArray;
        }
      }
      return [];
    },
    closeWarning() {
      this.show = false;
      this.$emit('closeEvent');
    },
  },
};
</script>

<style scoped>
.view {
  background: #fff;
}
.wrapper {
  background: #fff7bc;
  border-bottom: 2px solid #ffd41d;
  padding: 10px 0 15px 15px;
  display: flex;
  flex-direction: row;
}
.mask {
  position: fixed;
  z-index: 99998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
